import React from 'react';
import EventBus from 'eventing-bus';
import { useDispatch } from 'react-redux';
import { useMsal } from '@azure/msal-react';
import AppleSignin from 'react-apple-signin-auth';
import { useGoogleLogin } from '@react-oauth/google';

import { oauthConfig } from '../../store/config';
import { googleLogin, microsoftLogin, appleLogin } from '../../store/Auth';

const SocialLogin = ({ history, type }) => {
  const dispatch = useDispatch();
  const { instance: msalInstance } = useMsal();

  // Handle Google login success
  const handleGoogleSuccess = (response) => {
    if (response.credential) dispatch(googleLogin({ data: { idToken: response['credential'] }, history }));
    else if (response.access_token) dispatch(googleLogin({ data: { accessToken: response['access_token'] }, history }));
    else EventBus.publish('error', 'Google login failed. Please try again.');
  }

  // Handle Google login error
  const handleGoogleError = () => EventBus.publish('error', 'Google login failed. Please try again.');

  const googleSignIn = useGoogleLogin({
    onSuccess: handleGoogleSuccess,
    onError: handleGoogleError,
  });

  // Handle Microsoft login
  const handleMicrosoftLogin = async () => {
    try {
      const loginResponse = await msalInstance.loginPopup({ scopes: oauthConfig['microsoft']['scopes'], prompt: 'select_account' });
      if (loginResponse['accessToken']) dispatch(microsoftLogin({ data: { accessToken: loginResponse['accessToken'] }, history }));
      else {
        // Get access token using account
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
          const silentRequest = { scopes: oauthConfig['microsoft']['scopes'], account: accounts[0] };
          const silentResult = await msalInstance.acquireTokenSilent(silentRequest);
          dispatch(microsoftLogin({ data: { accessToken: silentResult['accessToken'] }, history }));
        }
      }
    } catch (error) {
      console.error('Microsoft login error:', error);
      EventBus.publish('error', 'Microsoft login failed. Please try again.');
    }
  }

  // Handle Apple login success
  const handleAppleSuccess = (response) => {
    if (response['authorization'] && response['authorization']['id_token']) 
      dispatch(appleLogin({ data: { idToken: response['authorization']['id_token'], user: response['user'] || {} }, history }));
    else EventBus.publish('error', 'Apple login failed. Please try again.');
  }

  // Handle Apple login error
  const handleAppleError = (error) => {
    console.error('Apple login error:', error);
    EventBus.publish('error', 'Apple login failed. Please try again.');
  }

  return (
    <div className="login-gmail-btn">
      <button className="g-btn" onClick={() => googleSignIn()} style={{ background: '#ffffff', color: '#1f1f1f', WebkitTextFillColor: '#1f1f1f', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" style={{ width: '18px', height: '18px', flexShrink: 0 }}>
          <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
          <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
          <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
          <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
        </svg>
        <span style={{ color: '#1f1f1f', WebkitTextFillColor: '#1f1f1f' }}>Continue with Google</span>
      </button>
      {/* <button className="micro-btn" onClick={handleMicrosoftLogin}>
        <i className="icon">
          <svg width="800px" height="800px" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="17" y="17" width="10" height="10" fill="#FEBA08" />
            <rect x="5" y="17" width="10" height="10" fill="#05A6F0" />
            <rect x="17" y="5" width="10" height="10" fill="#80BC06" />
            <rect x="5" y="5" width="10" height="10" fill="#F25325" />
          </svg>
        </i>
        {type || 'Sign up'} with Microsoft
      </button>
      
      <AppleSignin
        authOptions={{
          usePopup: true,
          scope: oauthConfig['apple']['scope'],
          clientId: oauthConfig['apple']['clientId'],
          redirectURI: oauthConfig['apple']['redirectUri'],
        }}
        onError={handleAppleError}
        onSuccess={handleAppleSuccess}
        render={({ onClick }) => (
          <button className="apple-btn" onClick={onClick}>
            <i className="icon">
              <svg width="800px" height="800px" viewBox="-1.5 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <g id="Dribbble-Light-Preview" transform="translate(-102.000000, -7439.000000)" fill="#000000">
                    <g id="icons" transform="translate(56.000000, 160.000000)">
                      <path d="M57.5708873,7282.19296 C58.2999598,7281.34797 58.7914012,7280.17098 58.6569121,7279 C57.6062792,7279.04 56.3352055,7279.67099 55.5818643,7280.51498 C54.905374,7281.26397 54.3148354,7282.46095 54.4735932,7283.60894 C55.6455696,7283.69593 56.8418148,7283.03894 57.5708873,7282.19296 M60.1989864,7289.62485 C60.2283111,7292.65181 62.9696641,7293.65879 63,7293.67179 C62.9777537,7293.74279 62.562152,7295.10677 61.5560117,7296.51675 C60.6853718,7297.73474 59.7823735,7298.94772 58.3596204,7298.97372 C56.9621472,7298.99872 56.5121648,7298.17973 54.9134635,7298.17973 C53.3157735,7298.17973 52.8162425,7298.94772 51.4935978,7298.99872 C50.1203933,7299.04772 49.0738052,7297.68074 48.197098,7296.46676 C46.4032359,7293.98379 45.0330649,7289.44985 46.8734421,7286.3899 C47.7875635,7284.87092 49.4206455,7283.90793 51.1942837,7283.88393 C52.5422083,7283.85893 53.8153044,7284.75292 54.6394294,7284.75292 C55.4635543,7284.75292 57.0106846,7283.67793 58.6366882,7283.83593 C59.3172232,7283.86293 61.2283842,7284.09893 62.4549652,7285.8199 C62.355868,7285.8789 60.1747177,7287.09489 60.1989864,7289.62485" id="apple-[#173]">
                      </path>
                    </g>
                  </g>
                </g>
              </svg>
            </i>
            {type || 'Sign up'} with Apple
          </button>
        )}
      /> */}
    </div>
  )
}

export default SocialLogin;